

import React, { memo } from 'react';
import BooleanValueAddon from '../../components/BooleanValueAddon';














// TODO: Get rid of this hof when will be no more projects with SUPER_RUSH_EDIT addon
// TODO: Also you should change graphql scheme by replacing RushEdit addon type from RushEditAddon to BooleanAddon
// TODO: Fix other backward compatibility code related to SUPER_RUSH_EDIT addon
/* istanbul ignore next */
function rushEditBackwardCompatibility(onChangeAddon) {
  return (addonValue) => {
    if (addonValue?.value) {
      return void onChangeAddon({
        value: 'RUSH_EDIT',
        cost: addonValue.cost,
        createdAt: addonValue.createdAt
      });
    }
    onChangeAddon(addonValue);
  };
}

function RushEdit({
  rushEdit,
  onChangeAddon,
  disabled,
  RUSH_EDIT,
  getAddonsCostByType,
  editingMode,
  getCurrencySymbol,
  viewMode,
  onCheckboxStateChange,
  showAboutInfo
}) {
  return (
    <BooleanValueAddon
      name="RUSH_EDIT"
      options={RUSH_EDIT}
      addonValue={rushEdit}
      title="Rush Edit"
      subtitle="Applies to 1st cut & 2 amendments. Subject to approval."
      icon="rushedit"
      onChangeAddon={rushEditBackwardCompatibility(onChangeAddon('RUSH_EDIT'))}
      disabled={disabled}
      viewMode={viewMode}
      getAddonsCostByType={getAddonsCostByType}
      editingMode={editingMode}
      getCurrencySymbol={getCurrencySymbol}
      onCheckboxStateChange={onCheckboxStateChange}
      showAboutInfo={showAboutInfo} />);


}

export default memo(RushEdit);